<!--
* @Name：综合类认定申请审批评审项模板
* @Author: 王超
* @Date: 2024-12-16
-->
<template>
  <div class="template" v-html="templateInfo" />
</template>

<script>
export default {
  name: 'BankInfo',
  data() {
    return {}
  },
  props: {
    // 模板数据，html格式
    templateInfo: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.template {
  padding: 0px 10px;
}
</style>
